import * as React from "react";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Button, Typography, Alert } from "@mui/material";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import useMediaQuery from "@mui/material/useMediaQuery";
import Collapse from "@mui/material/Collapse";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { LoadingSvg } from "../../../../utils/SvgIcons";
import Tooltip from "@mui/material/Tooltip";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import IconButton from "@mui/material/IconButton";
import DialogData from "./DialogData";
import Divider from "@mui/material/Divider";
import { getBankAccountsApi } from "../../../../../../services/accountingApi";
import ModeEditIcon from "@mui/icons-material/ModeEdit";

// import DisableCode from "./DisableCode";
// import ShowDetailsCode from "./ShowDetailsCode";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, data) {
  return { name, data };
}


// دیتاهای مورد نیاز و اسم نمایشی آنها را تعین میکند
const neededBankCardsData = {
  bankName: "نام بانک",
  bankCartNumber: "شماره کارت بانکی",
  bankAccountNumber: "شماره حساب بانکی",
  bankShaba: "شماره شبا",
  situation: "وضعیت حساب",
};

export default function GetBankAccounts({ handleSetBankInfo, handleCloseDialogContent }) {

  // اگر سایز صفحه از 600 پیکسل کوچکتر شود مقدار ترو برمیگرداند
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [bankCardsData, setBankCardsData] = useState({ docs: [] });

  const [controlAlert, setControlAlert] = useState({
    open: true,
    message: "لطفا صبر کنید",
    severity: "warning",
    SkeletonDisplay: "none",
  });

  const [pageAndPerPage, setPageAndPerPage] = useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
  });

  const getBankCardsDataFromBack = async (request, data, paginateData = {}) => {
    try {
      setControlAlert({
        open: true,
        message: "لطفا صبر کنید",
        severity: "warning",
        SkeletonDisplay: "Block",
      });
      setBankCardsData({ docs: [] });
      let paginate = { ...pageAndPerPage, ...paginateData };
      if (request == "getBankAccountsApi") {
        let received = await getBankAccountsApi(data, paginate);
        // let received = fetchedSubtitlesListSample;
        // console.log("amireer", received["data"]["data"]["docs"]);
        if (received.data.success) {
          setBankCardsData(received["data"]["data"]);
          setControlAlert({
            open: false,
            message: "جواب آمد",
            severity: "warning",
            SkeletonDisplay: "none",
          });
          const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
            received["data"]["data"];
          const newValues = {
            totalPages,
            hasNextPage,
            hasPrevPage,
            page,
            totalDocs,
          };
          setPageAndPerPage({
            ...pageAndPerPage,
            ...paginateData,
            ...newValues,
          });
        } else {
          setControlAlert({
            open: true,
            message: "مشکلی پیش آمده است",
            severity: "warning",
            SkeletonDisplay: "none",
          });
        }
      }
    } catch (error) {
      // console.log("getBankCardsDataFromBack", error)
      if (error["response"]["data"]["message"])
        setControlAlert({
          open: true,
          message: error["response"]["data"]["message"],
          severity: "warning",
          SkeletonDisplay: "none",
        });
    }
  };


  const RecivedBankCardsData = bankCardsData["docs"];
  // کنترل شماره صفحه و تعداد در هر صفحه
  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getBankCardsDataFromBack("getBankAccountsApi", {}, PageAndPerPageValue);
  };

  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه از listOfTable میریزد
  let listOfBankCardTable =
    RecivedBankCardsData.length > 0
      ? RecivedBankCardsData.map((el, index) => {
        const rowOfTableData = [];
        rowOfTableData[0] = el;
        for (const property in el) {
          // دیتاهایی که در neededBankCardsData گفته ایم نیاز داریم را جدا می کند
          if (neededBankCardsData[property]) {
            // دیتاهایی که  بصورت تاریخ هستند - باید خودمان مشخص کنیم-. را تبدیل به تاریخ شمسی میکند
            if (
              property == "createdAt" ||
              property == "endingDate" ||
              property == "startingDate"
            ) {
              const date = new DateObject({
                date: el[property],
                calendar: persian,
                locale: persian_fa,
              });
              rowOfTableData.push(
                createData(neededBankCardsData[property], {
                  name: property,
                  data: date.format(),
                })
              );
            } else
              rowOfTableData.push(
                createData(neededBankCardsData[property], {
                  name: property,
                  data: el[property],
                })
              );
          }
        }
        return rowOfTableData;
      })
      : [];

  useEffect(() => {
    getBankCardsDataFromBack("getBankAccountsApi", {});
  }, []);
  // اطلاعات هر سطر را بر میگرداند و در صورت نیاز قبل از برگرداندن تغیراتی روی دیتا انجام می دهیم

  const showRowBankCardData = (index, data, oneRow) => {
    const { name, data: content } = data;
    if (name == "situation") {
      // console.log(content);
      switch (content) {
        case "initialRegistration":
          return <StyledTableCell align="left">منتظر تایید</StyledTableCell>;
        case "editAcademyInfo":
          return <StyledTableCell align="left">رد عضویت</StyledTableCell>;
        case "studentOfAcademy":
          return <StyledTableCell align="left">منتظر تایید</StyledTableCell>;
        case "masterOfAcademy":
          return <StyledTableCell align="left">منتظر تایید</StyledTableCell>;
        default:
          return "Error";
      }
    } else {
      return <StyledTableCell align="left">{content}</StyledTableCell>;
    }
  };

  return (
    <>
      <Box>
        <Box
          sx={{
            backgroundColor: "#0f014a",
            width: "100%",
            borderRadius: "10px",
            py: 1,
            px: 2,
            mb: 1,
          }}
        >
          شماره کارت های بانکی:
        </Box>
        <Collapse in={controlAlert.open}>
          <Alert
            severity={controlAlert.severity}
            sx={{ mb: 2 }}
          >
            {controlAlert.message}
          </Alert>
        </Collapse>
        <Stack sx={{ display: controlAlert.SkeletonDisplay }} spacing={1}>
          <Skeleton />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </Stack>
        {listOfBankCardTable.map((oneRow, index) => (
          <TableContainer
            key={`MainTable-${index}`}
            component={Paper}
            sx={{ mb: 1 }}
          >
            <Table sx={{ minWidth: 10 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "25%" : "50%" }}
                  >{`کارت ${index + 1}`}</StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "75%" : "50%" }}
                    align="left"
                  ></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {oneRow.map((row, indexrow) =>
                  indexrow == 0 ? (
                    <IconButton
                      sx={{ ml: 2 }}
                      aria-label="edit"
                      color="warning"
                      onClick={(e) => {
                        const data = { bankCheckoutInfo: row["_id"], bankCheckoutCardNumber: row["bankCartNumber"].toString(), bankName: row["bankName"], bankCardStatus: row["status"] }
                        handleSetBankInfo(data)
                        handleCloseDialogContent()
                      }}
                    >
                      <CreditScoreIcon />
                      <Typography>
                        انتخاب
                      </Typography>
                    </IconButton>
                  ) : (
                    <StyledTableRow key={`${row.name}-${indexrow}`}>
                      <StyledTableCell component="th" scope="row">
                        {row.name}
                      </StyledTableCell>
                      {/* {console.log(row.data)} */}
                      {showRowBankCardData(index, row.data, oneRow)}
                    </StyledTableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ))}
      </Box>
    </>
  );
}
